<div class="billing-history-search">
  <form class="billing-history-search__form" [formGroup]="searchForm">
    <div class="billing-history-search__form-row">
      <div class="billing-history-search__form-row__left-col">
        <date-range-picker
          id="paidDateFrom"
          name="paidDateFrom"
          placeholder="FORM_PLACEHOLDER.DATES"
          [fc]="searchForm.get('paidDateFrom')"
          (search)="onDateRangeSelect($event)"
        ></date-range-picker>

        <div class="billing-history-search__service-input-wrapper">
          <auto-select
            id="productCodes"
            formGroupClass="m-0"
            ngSelectClass="custom-billing-dropdown"
            bindValue="value"
            bindLabel="label"
            bindOption="label"
            [placeholder]="'FORM_PLACEHOLDER.SERVICE' | translate"
            [fc]="searchForm.get('productCodes')"
            [items]="serviceItems"
            [multiple]="true"
            [isShowHelper]="false"
            [hideSelected]="false"
            [closeOnSelect]="false"
            [optionTemplate]="productCodeOptionTemplate"
          />
        </div>

        <div *ngIf="companies?.length > 1" class="billing-history-search__company-input-wrapper">
          <ng-select
            class="custom-billing-dropdown"
            [formControl]="searchForm.get('companyId')"
            [id]="'companyId'"
            [placeholder]="'FORM_PLACEHOLDER.IMPORTER_OF_RECORD' | translate"
            [items]="companyItems"
            [multiple]="false"
            [bindLabel]="'label'"
            [bindValue]="'value'"
          ></ng-select>
        </div>
      </div>

      <div class="billing-history-search__form-row__right-col">
        <app-search-input
          id="searchParameter"
          name="searchParameter"
          clearButtonIconSrc="/assets/icons/icon_close_gray_sm.svg"
          placeholder="FORM_PLACEHOLDER.BILLING_HISTORY_SEARCH_BY"
          [formControlDirective]="searchForm.get('searchParameter')"
          [submitOnChange]="true"
          [isFullWidth]="isMobile"
          [isIconSubmittable]="false"
          (submit)="onSearchSubmit($event)"
          (clear)="onSearchClear()"
        ></app-search-input>
      </div>
    </div>
  </form>
</div>

<ng-template #productCodeOptionTemplate let-item="item" let-item$="item$" let-index="index">
  <div class="d-flex justify-content-between align-items center">
    <span [title]="item.label | translate">
      {{ item.label | translate }}
    </span>
    <div for="item-{{ index }}" class="custom-checkbox-container" [title]="item.label | translate">
      <input
        id="item-{{ index }}"
        class="custom-checkbox-container__input"
        type="checkbox"
        [ngModel]="item$.selected"
        [ngModelOptions]="{ standalone: true }"
      />
      <span class="custom-checkbox-container__checkmark"></span>
    </div>
  </div>
</ng-template>
